(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ambrelle-buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ambrelle-buy-box')) {
    class AmbrelleBuyBox extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('change', () => this.apply(true), { signal: this.controller.signal });
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.apply(false), { once: true, signal: this.controller.signal });
        } else {
          this.apply(false);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      get form() {
        return document.getElementById(this.dataset.formId || '');
      }

      apply(fromUser) {
        const radio = this.querySelector('.ambrelle-buybox__radio:checked');
        const form = this.form;
        if (!(radio instanceof HTMLInputElement)) return;

        const plan = this.querySelector('[data-plan-input]');
        if (plan instanceof HTMLInputElement) {
          plan.disabled = !radio.dataset.planId;
          if (radio.dataset.planId) plan.value = radio.dataset.planId;
        }

        const idInput = form?.querySelector('input[name="id"]');
        if (idInput instanceof HTMLInputElement && radio.dataset.variantId) idInput.value = radio.dataset.variantId;

        const available = radio.dataset.available === 'true';
        const label = available ? radio.dataset.cta : this.dataset.soldOut;
        const button = form?.querySelector('[ref="addToCartButton"]');
        if (button instanceof HTMLButtonElement) {
          button.disabled = !available;
          const text = button.querySelector('.add-to-cart-text__content');
          if (text) text.textContent = label || '';
        }

        if (fromUser && this.dataset.updateUrl === 'true' && radio.dataset.variantId) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.dataset.variantId);
          if (radio.dataset.planId) url.searchParams.set('selling_plan', radio.dataset.planId);
          else url.searchParams.delete('selling_plan');
          window.history.replaceState(window.history.state, '', url.toString());
        }

        this.dataset.offer = radio.value;
        this.state = {
          sectionId: this.dataset.sectionId,
          offer: radio.value,
          price: radio.dataset.sticky || '',
          cta: label || '',
          available,
        };
        document.dispatchEvent(new CustomEvent('ambrelle:offer-change', { detail: this.state }));
      }
    }

    customElements.define('ambrelle-buy-box', AmbrelleBuyBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ambrelle-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ambrelle-nav')) {
    class AmbrelleNav extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-panel]');
        this.triggers = Array.from(this.querySelectorAll('[data-trigger]'));
        if (!this.panel || !this.triggers.length) return;
        const hover = window.matchMedia('(hover: hover)').matches;
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => (this.isOpen && this.active === trigger ? this.close() : this.open(trigger)));
          if (hover) {
            trigger.addEventListener('mouseenter', () => this.schedule(() => this.open(trigger), 90));
            trigger.addEventListener('mouseleave', () => this.schedule(() => this.close(), 180));
          }
        });
        if (hover) {
          this.panel.addEventListener('mouseenter', () => this.schedule(null));
          this.panel.addEventListener('mouseleave', () => this.schedule(() => this.close(), 180));
        }
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.isOpen) {
            const back = this.active;
            this.close();
            back?.focus();
          }
        });
        this.addEventListener('focusout', (event) => {
          if (this.isOpen && !this.contains(event.relatedTarget)) this.close();
        });
        this.onScroll = () => this.isOpen && this.place();
        window.addEventListener('resize', this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onScroll);
      }

      schedule(action, delay = 0) {
        window.clearTimeout(this.timer);
        if (action) this.timer = window.setTimeout(action, delay);
      }

      /* Le panneau se place sous l'en-tête, quelle que soit sa hauteur (barre du ciel, en-tête collant). */
      place() {
        const header = this.closest('#header-component, header, .header') || this;
        this.panel.style.setProperty('--amb-nav-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
      }

      open(trigger) {
        this.schedule(null);
        this.place();
        this.triggers.forEach((t) => t.setAttribute('aria-expanded', String(t === trigger)));
        this.active = trigger;
        this.panel.hidden = false;
        this.isOpen = true;
        this.dataset.open = '';
      }

      close() {
        this.schedule(null);
        this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        this.panel.hidden = true;
        this.isOpen = false;
        delete this.dataset.open;
      }
    }
    customElements.define('ambrelle-nav', AmbrelleNav);
  }

  if (!customElements.get('ambrelle-nav-drawer')) {
    class AmbrelleNavDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-open]');
        if (!this.dialog || !this.opener) return;
        this.opener.addEventListener('click', () => {
          this.dialog.showModal();
          this.opener.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('amb-drawer-open');
        });
        this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          this.opener.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('amb-drawer-open');
          this.opener.focus();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.querySelectorAll('select[data-autosubmit]').forEach((select) => {
          select.addEventListener('change', () => select.form?.submit());
        });
      }
    }
    customElements.define('ambrelle-nav-drawer', AmbrelleNavDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ambrelle-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ambrelle-sticky-atc')) {
    class AmbrelleStickyAtc extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.mainVisible = true;
        this.footerVisible = false;
        this.keyboard = false;
        this.querySelector('[data-sticky-button]')?.addEventListener('click', () => this.submit(), { signal });
        document.addEventListener('ambrelle:offer-change', (event) => this.update(event.detail), { signal });
        window.visualViewport?.addEventListener(
          'resize',
          () => {
            const viewport = window.visualViewport;
            if (!viewport) return;
            this.keyboard = viewport.height < window.innerHeight * 0.75;
            this.render();
          },
          { signal }
        );
        const start = () => {
          const box = document.querySelector(`ambrelle-buy-box[data-section-id="${this.dataset.sectionId}"]`);
          if (box && box.state) this.update(box.state);
          this.observe();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
        else start();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.reobserve) document.removeEventListener('ambrelle:offer-change', this.reobserve);
      }

      get mainButton() {
        const form = document.getElementById(this.dataset.formId || '');
        const button = form?.querySelector('[ref="addToCartButton"]');
        return button instanceof HTMLButtonElement ? button : null;
      }

      /* La barre reste cachée tant que le bouton principal OU la formule cochée est réellement lisible (60 % visible) :
         elle ne recouvre pas l'offre qu'on lit, et elle reste là tant que seul le titre du bloc d'achat dépasse. */
      observe() {
        this.observer?.disconnect();
        const button = this.mainButton || document.getElementById(this.dataset.formId || '');
        const box = document.querySelector(`ambrelle-buy-box[data-section-id="${this.dataset.sectionId}"]`);
        const checked = box?.querySelector('.ambrelle-buybox__radio:checked')?.closest('.ambrelle-buybox__offer');
        const targets = [button, checked].filter(Boolean);
        if (!targets.length) return;
        const footer = document.querySelector('footer');
        const seen = new Set();
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.target === footer) this.footerVisible = entry.isIntersecting;
              else if (entry.intersectionRatio >= 0.6) seen.add(entry.target);
              else seen.delete(entry.target);
            }
            this.mainVisible = seen.size > 0;
            this.render();
          },
          { threshold: [0, 0.6, 1] }
        );
        for (const target of targets) this.observer.observe(target);
        if (footer) this.observer.observe(footer);
        if (!this.reobserve) {
          this.reobserve = () => this.observe();
          document.addEventListener('ambrelle:offer-change', this.reobserve);
        }
      }

      render() {
        const bar = this.querySelector('.ambrelle-sticky__bar');
        if (!(bar instanceof HTMLElement)) return;
        const visible = !this.mainVisible && !this.footerVisible && !this.keyboard;
        bar.dataset.visible = String(visible);
        bar.inert = !visible;
      }

      update(detail) {
        if (!detail || detail.sectionId !== this.dataset.sectionId) return;
        const price = this.querySelector('[data-sticky-price]');
        if (price && detail.price) price.textContent = detail.price;
        const button = this.querySelector('[data-sticky-button]');
        if (button instanceof HTMLButtonElement) {
          button.disabled = !detail.available;
          if (detail.cta) button.textContent = detail.cta;
        }
      }

      submit() {
        const main = this.mainButton;
        if (main && !main.disabled) main.click();
      }
    }

    customElements.define('ambrelle-sticky-atc', AmbrelleStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
